module.exports = __webpack_public_path__ + "static/img/09017B_3_R_20190614_fit.5e71090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09017B_3_R_20190614_fit.png
// module id = 5ySF
// module chunks = 0